export enum Tier {
  Blue = 1,
  Bronze = 2,
  Silver = 3,
  Gold = 4,
  Diamond = 5,
  Black = 6
}
